import {
  MESSAGE_SHOW,
  MESSAGE_HIDE
} from './types'

const initialState = {
  isDisplayed: false,
  label: '',
  description: '',
  duration: 5000
}

const getters = {
  isDisplayed: state => state.isDisplayed
}

const mutations = {
  [MESSAGE_SHOW] (state, message) {
    state.isDisplayed = true
    state.label = message.label
    state.description = message.description
    if ('duration' in message) {
      state.duration = message.duration
    } else {
      state.duration = initialState.duration
    }
  },
  [MESSAGE_HIDE] (state) {
    state.isDisplayed = false
    state.label = ''
    state.description = ''
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/messages.js